export default __webpack_public_path__ + "static/media/R07_INTEGRATE-1.921305ab.png";